export class SituacaoProf {
  public situacaoProf?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
